import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { Avatar, type AvatarProps } from '@mantine/core'

import { useQueryGetUserLogged } from '@flecto/core/shared'
import { getImageUrl } from '@flecto/utils'

import { Icon } from '..'

export function AvatarUserLogged(props: AvatarProps) {
  const { data } = useQueryGetUserLogged()

  const image = data?.links.avatar_url
    ? getImageUrl(data?.links.avatar_url)
    : undefined

  return (
    <Avatar size='md' {...props} src={image}>
      <Icon icon={faUser} data-testid='avatar-icon' />
    </Avatar>
  )
}
